export const Progress = {
  baseStyle: {
    filledTrack: {
      bg: '#1A1F5A',
    },
  },
};
